<template>
	<div>
		<transition>
			<b-container fluid>
				<b-row align-h="center" class="mb-5 mt-5">
					<!-- <h2 class="textBlue">
						{{ $t("login.login") }}
					</h2> -->
				</b-row>

				<b-form
					@submit.stop.prevent="getForgotPassMobile"
					v-show="show_melliCode"
				>
					<b-row align-h="center">
						<b-col md="9" cols="9">
							<b-form-group
								id="melli_code_group"
								:label="$t('login.melliCode')"
								label-for="melli_code"
							>
								<b-form-input
									id="melli_code"
									type="number"
									v-model="$v.melli_code.$model"
									:state="validateState('melli_code')"
								>
								</b-form-input>
								<b-form-invalid-feedback
									id="melli_code-live-feedback"
									v-show="!$v.melli_code.required"
								>
									{{ $t("validation.required") }}
								</b-form-invalid-feedback>
								<b-form-invalid-feedback
									id="melli_code-live-feedback"
									v-show="!$v.melli_code.checkMelliCode"
								>
									{{ $t("validation.MelliCodeCheck") }}
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>

					<b-row align-h="center" class="justify-content-center">
						<b-col cols="9">
							<div>
								<b-button
									type="submit"
									size="md"
									class="btn btn-hover--3d btn-left btn-bg--primary"
									>{{ $t("register.save") }}
								</b-button>
							</div>
						</b-col>
					</b-row>
				</b-form>
				<b-form v-show="show_mobileNumber">
					<b-row align-h="center" class="mb-3">
						<b-col md="9" cols="9">
							
								{{ $t("forgotpass.note.sec1") }} <span dir="ltr"><b>{{ form.mobile_number }}</b></span>
									{{ $t("forgotpass.note.sec3") }}
								
						
						</b-col>
					</b-row>
					<b-form-input
									id="melli_code"
									type="number"
									v-model="otp"
									class="col-9 mx-auto"
								>
								</b-form-input>
								<b-row align-h="center" class="justify-content-center">
						<b-col cols="9">
							<div>
								<b-button
								   @click="sendOtp"
									
									size="md"
									class="btn btn-hover--3d btn-left btn-bg--primary mb-2"
									>تایید
								</b-button>
							</div>
						</b-col>
					</b-row>
					 <small class="text-color--400  mt-4 ">
									<center>
										<a
											role="button"
											type="button"
											:disabled="counting"
											@click="startCountdown"
										>
											<countdown
												v-if="counting"
												:time="120000"
												@end="handleCountdownEnd"
												class="text-color--400 font-size--10 mt-2 mt-sm-0 text-center"
											>
												<template slot-scope="props">
													ارسال دوباره کد بعد از
													{{ props.totalSeconds }} ثانیه
												</template>
											</countdown>
											<span
												class="text-color--400 font-size--10 mt-2 mt-sm-0 text-center"
												v-else
												><a class="btn" role="button" @click="getForgotPassMobile">
													{{ $t("register.otppage.resendCode") }}</a
												></span
											>
										</a>
									</center>
								</small> 
					

					<!-- <b-row align-h="center">
						<b-col cols="4">
							<div>
								<b-button
									type="button"
									size="md"
									@click.prevent="accept"
									variant="primary"
									class="btn btn-hover--3d"
									>{{ $t("forgotpass.ok") }}
								</b-button>
							</div>
						</b-col>
						<b-col cols="4">
							<div>
								<b-button
									type="button"
									size="md"
									@click.prevent="reject"
									variant="danger"
									class="btn btn-hover--3d "
									>{{ $t("forgotpass.notOk") }}
								</b-button>
							</div>
						</b-col>
					</b-row> -->
				</b-form>

				<b-form @submit.stop.prevent="getForgotPass" v-show="show_password">
				   
					<b-row align-h="center">
						<b-col md="9" cols="9">
							<b-form-group
								id="password_group"
								:label="$t('register.password')"
								label-for="password"
							>
								<b-form-input
									id="password"
									type="password"
									v-model="$v.form.new_password.$model"
									:state="validateStateForm('new_password')"
								>
								</b-form-input>
								<b-form-invalid-feedback id="new_password-live-feedback" v-show="!$v.form.new_password.required">
									{{ $t("validation.required") }}
								</b-form-invalid-feedback>
								<b-form-invalid-feedback id="new_password-live-feedback" v-show="!$v.form.new_password.minLength">
									{{ $t("validation.passMinLength") }}
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row align-h="center">
						<b-col md="9" cols="9">
							<b-form-group
								id="re_password_group"
								:label="$t('register.rePassword')"
								label-for="otp"
							>
								<b-form-input
									id="otp"
									type="password"
									v-model="$v.new_re_password.$model"
									:state="validateState('new_re_password')"
								>
								</b-form-input>
								<b-form-invalid-feedback id="otp-live-feedback" v-show="!$v.new_re_password.required">
									{{ $t("validation.required") }}
								</b-form-invalid-feedback>
								<b-form-invalid-feedback id="otp-live-feedback" v-show="$v.new_re_password.required & !$v.new_re_password.same" >
									{{ $t("validation.repasswordInvalid") }}
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>

					<b-row align-h="center" class="justify-content-center">
						<b-col cols="9">
							<div @click=sendNewPassword>
								<b-button
									
									size="md"
									class="btn btn-hover--3d btn-left btn-bg--primary"
									>{{ $t("register.save") }}
								</b-button>
							</div>
						</b-col>
					</b-row>
				</b-form>
				<b-row align-h="center" class="mb-5 pb-3">
					<b-col md="8" cols="9">
						<hr />
						<small class="text-color--400 ">
							{{$t("login.havePass")}}
							<b-link to="/newLogin"> {{ $t("login.login") }}</b-link>
						</small>
					</b-col></b-row
				>
			</b-container>
		</transition>
	</div>
</template>

<script>
import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import Countdown from "@chenfengyuan/vue-countdown";

import { required , minLength} from "vuelidate/lib/validators";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
export default {
	data() {
		return {
			show_melliCode: true,
			show_mobileNumber: false,
			show_password: false,
			melli_code: "",
			otp:"",
			counting: false,
			form: {
				
				otp: "",
				mobile_number: "",
				new_password: "",
			},
			new_re_password: "",
		};
	},
	validations: {
		melli_code: {
				required,
				checkMelliCode(code) {
					if (
						!/^\d{10}$/.test(code) ||
						code == "0000000000" ||
						code == "1111111111" ||
						code == "2222222222" ||
						code == "3333333333" ||
						code == "4444444444" ||
						code == "5555555555" ||
						code == "6666666666" ||
						code == "7777777777" ||
						code == "8888888888" ||
						code == "9999999999"
					)
						return false;
					var check = parseInt(code[9]);
					var sum = 0;
					var i;
					for (i = 0; i < 9; ++i) {
						sum += parseInt(code[i]) * (10 - i);
					}
					sum %= 11;
					return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
				},
			},
		otp:{
			required
		},
		form: {
			
			otp:{required},
			new_password: { required,minlength:minLength(6) },
		},
		new_re_password: {
			required,
			same(pass) {
				if (pass == this.form.new_password) {
					return true;
				}
				return false;
			},
		},
	},
	methods: {
		sendNewPassword()
		{
			if(!this.$v.new_re_password.$invalid && !this.$v.form.new_password.$invalid)
			{

			
			let load = this.$loading.show();
				this.$store
					.dispatch("checkForgotPassOtp", {melli_code:this.melli_code,new_password:this.form.new_password})
					.then((response) => {
						console.log(response);
						this.$noty.success(response.body.message);
						
						load.hide();
						this.$router.push('newLogin')
						
						
						
					})
					.catch((err) => {
						
						
						console.log(err);
						this.$noty.error(err.body.error);
						load.hide();
					});
			}
			else if (!this.$v.new_re_password.$required || !this.$v.form.new_password.$required )
			{
				this.$noty.error(this.$t("alert.alertInvalidField"));
			}
			else 
			{
					this.$noty.error(this.$t("مشکلات مشخص شده را رفع نمایید"));
			}
		},
		sendOtp()
		{
			if(this.$v.otp.$invalid)
			{
				this.$noty.error(this.$t("alert.alertInvalidField"));
			}
			else
			{
				let load = this.$loading.show();
				this.$store
					.dispatch("checkForgotPassOtp", {melli_code:this.melli_code,token:this.otp})
					.then((response) => {
						console.log(response);
						load.hide();
						if(response.status==202)
						{
							this.$noty.success(response.body.message)
							this.show_password = true
							this.show_mobileNumber = false
							this.show_melliCode = false
						}
						
						
					})
					.catch((err) => {
						
						
						console.log(err);
						this.$noty.error(err.body.error);
						load.hide();
					});
			
			}
			
				
		},
		getForgotPassMobile() {
			this.$v.melli_code.$touch();
			if (this.$v.melli_code.$invalid) {
				console.log(this.$v.form);
				this.$noty.info(this.$t("alert.alertInvalidField"));
			} else {
				let load = this.$loading.show();
				this.$store
					.dispatch("getForgotPassOtp", this.melli_code)
					.then((response) => {
						console.log(response);
						load.hide();
						this.form.mobile_number = response.body.mobile_number;
						this.show_mobileNumber = true;
						this.show_melliCode = false;
						this.startCountdown()
					})
					.catch((err) => {
						
						this.show_mobileNumber = false;
						this.show_melliCode = false;
						console.log(err);
						this.$noty.error(err.body.error);
						load.hide();
					});
			}
		},
		accept() {
			let load = this.$loading.show();
			this.$store
				.dispatch("getForgotPassOtp", {
					melli_code: this.melli_code,
					mobile_number: this.form.mobile_number,
				})
				.then((response) => {
					console.log(response);
					load.hide();
					this.$noty.success(response.body.message)
					this.show_mobileNumber = false;
					this.show_melliCode = false;
					this.show_password = true;
				})
				.catch((err) => {
					console.log(err);
					this.$noty.error(err.body.error);
					load.hide();
				});
		},
		reject() {
			this.show_melliCode = true;
			this.show_mobileNumber = false;
			this.show_password = false;
		},
		getForgotPass() {
			this.$v.melli_code.$touch();
			if (this.$v.melli_code.$invalid) {
				console.log(this.$v.form);
				this.$noty.info(this.$t("alert.alertInvalidField"));
			} else {
				let load = this.$loading.show();
				this.$store
					.dispatch("ForgotPassChange", this.form)
					.then((response) => {
						console.log(response);
						load.hide();
						this.form.mobile_number = response.body.mobile_number;
						this.show_mobileNumber = true;
						this.show_melliCode = false;
					})
					.catch((err) => {
						console.log(err);
						this.$noty.error(err.body.error);
						load.hide();
					});
			}
		},
		startCountdown() {
			this.counting = true;
		},
		handleCountdownEnd() {
			this.counting = false;
		},
		validateStateForm(name) {
			const { $dirty, $error } = this.$v.form[name];
			return $dirty ? !$error : null;
		},
		validateState(name) {
			const { $dirty, $error } = this.$v[name];
			return $dirty ? !$error : null;
		},
	},
	components:
	{
		Countdown
	}
};
</script>

<style scoped>
.btn-left {
	display: block;
	margin-right: auto;
}
</style>
<style scoped scr="bootstrap/dist/css/bootstrap.css">

</style>
<style scoped scr="bootstrap-vue/dist/bootstrap-vue.csss"></style>

